import infoTokens from '@amzn/meridian-tokens/base/icon/info';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';

interface Props {
  message: string;
}

const ErrorMessage: React.FC<Props> = ({
  message,
}: Props): React.ReactElement | null => {
  return message ? (
    <Row spacing='200' spacingInset='none' alignmentVertical='center'>
      <Icon tokens={infoTokens} />
      <Text color='error'>{message}</Text>
    </Row>
  ) : null;
};

export default ErrorMessage;
